import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ValueSection } from './components/ValueSection';
import { IndustriesSection } from './components/IndustriesSection';
import { ProgramsSection } from './components/ProgramsSection';
import { ResourcesSection } from './components/ResourcesSection';
import { TeamsSection } from './components/TeamsSection';
import { TrustSection } from './components/TrustSection';
import { CTABanner } from './components/CTABanner';
import { Footer } from './components/Footer';
import { Link } from 'react-router-dom';
export function App() {
  return <div className="flex flex-col w-full min-h-screen bg-white text-charcoal" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <div className="fixed top-20 right-4 z-50" data-id="element-3">
          <Link to="/minimal-home" className="inline-block px-4 py-2 bg-teal text-white rounded-md shadow-md hover:bg-teal/90 transition-colors" data-id="element-4">
            View Minimal Ireland Home
          </Link>
        </div>
        <HeroSection data-id="element-5" />
        <ValueSection data-id="element-6" />
        <IndustriesSection data-id="element-7" />
        <ProgramsSection data-id="element-8" />
        <ResourcesSection data-id="element-9" />
        <TeamsSection data-id="element-10" />
        <TrustSection data-id="element-11" />
        <CTABanner data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}